// Imports
import { AudioPlayer } from './scripts/audio-player';
import { ImageLoader } from './scripts/images';
import { SpritePlayer } from './scripts/sprite-animation';
import { WaterFacts } from './scripts/water-facts';
import axios from 'axios';

// Variables
const elements = {
	actionOverlay: document.getElementById('action-overlay') as HTMLElement,
	tapGesture: document.getElementById('tap-gesture') as HTMLElement,
	rainFirstFrame: document.querySelector('#rain-first-frame') as HTMLImageElement,
	snowFirstFrame: document.querySelector('#snow-first-frame') as HTMLImageElement,
	rainGif: document.querySelector('.rain-overlay') as HTMLImageElement,
	snowflakesGif: document.querySelector('.snowflakes') as HTMLImageElement,
	signPost: {
		topLink: document.querySelector('#sign-post-top-link') as HTMLElement,
		bottomLink: document.querySelector('#sign-post-bottom-link') as HTMLElement,
	},
};

let currentPlayingGif = 'rain';
let userInputTimeout: any;

// Classes
const waterFacts = new WaterFacts();
const audio = AudioPlayer.getInstance();
const imageLoader = new ImageLoader();

// Sprites
const destroySnowElement = document.getElementById('snow-destroy');
const snowDestroySprite = new SpritePlayer({
	spriteElement: destroySnowElement,
	spriteFrames: 7,
});

const waterSplashElement = document.getElementById('water-splash');
const waterSplashSprite = new SpritePlayer({
	spriteElement: waterSplashElement,
	spriteFrames: 5,
});

// Before Experience Starts

if (!localStorage.getItem('region')) {
	axios.get('https://freegeoip.app/json/').then((result) => {
		if (result.data.country_code === 'AU') {
			localStorage.setItem('region', 'AU');
		} else {
			localStorage.setItem('region', 'US');
		}
	});
}

imageLoader.loadImages();

// Event Listeners

elements.actionOverlay.addEventListener('click', () => {
	clearTimeout(userInputTimeout);
	if (currentPlayingGif === 'snow') {
		elements.snowFirstFrame.classList.add('fall');
		waitForUserInput(() => {
			elements.snowFirstFrame.click();
		});
	} else if (currentPlayingGif === 'rain') {
		elements.rainFirstFrame.classList.add('fall');
		waitForUserInput(() => {
			elements.rainFirstFrame.click();
		});
	}
	setTimeout(() => {
		elements.tapGesture.style.display = 'block';
	}, 800);
});

elements.rainFirstFrame?.addEventListener('click', () => {
	audio.bubblePop.play();
	setTimeout(() => {
		clearTimeout(userInputTimeout);
		waterFacts.preloadFact();
		elements.tapGesture.style.display = 'none';
		elements.rainFirstFrame.style.display = 'none';
		waterSplashSprite.play();
		setTimeout(() => {
			elements.rainFirstFrame.classList.remove('fall');
			elements.rainFirstFrame.style.display = 'block';
			waterFacts.showFact();
			waterSplashSprite.hide();
		}, 300);
	});
});

elements.snowFirstFrame?.addEventListener('click', () => {
	audio.iceSwoosh.play();
	setTimeout(() => {
		clearTimeout(userInputTimeout);
		waterFacts.preloadFact();
		elements.tapGesture.style.display = 'none';
		snowDestroySprite.play();
		elements.snowFirstFrame.style.display = 'none';
		setTimeout(() => {
			elements.snowFirstFrame.classList.remove('fall');
			elements.snowFirstFrame.style.display = 'block';
			waterFacts.showFact();
			snowDestroySprite.hide();
		}, 300);
	});
});

waterFacts.waterFactElement.addEventListener('click', () => {
	waterFacts.hideFact();
	clearTimeout(userInputTimeout);
	waitForUserInput(() => {
		elements.actionOverlay.click();
	});
});

elements.signPost.topLink.addEventListener('click', () => {
	const region = localStorage.getItem('region');
	if (region === 'AU') {
		window.location.href = 'https://justwater.com/pages/australia';
	} else {
		window.location.href = 'https://justwater.com/collections/just-water';
	}
});

elements.signPost.bottomLink.addEventListener('click', () => {
	window.location.href = 'https://justwater.com/pages/AR';
});

const waitForUserInput = (callback: () => void) => {
	userInputTimeout = setTimeout(() => {
		callback();
	}, 5000);
};

setInterval(() => {
	if (currentPlayingGif === 'rain') {
		currentPlayingGif = 'snow';
		elements.rainGif.style.opacity = '0';
		elements.snowflakesGif.style.opacity = '1';
	} else {
		currentPlayingGif = 'rain';
		elements.rainGif.style.opacity = '1';
		elements.snowflakesGif.style.opacity = '0';
	}
}, 8000);

imageLoader.eventEmitter.addEventListener('start', () => {
	elements.tapGesture.style.display = 'block';
	setTimeout(() => {
		elements.tapGesture.style.display = 'none';
	}, 3000);
	waitForUserInput(() => {
		elements.actionOverlay.click();
	});
});
